import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { ModalContext } from "mobile/components/Modal/ModalOverlay/Context"

const useHandleErrorModal = () => {
  const { handleModal } = useContext(ModalContext)
  const { t } = useTranslation(["sales"])

  const errorModal = (errorMessage) => {
    handleModal({
      status: "error",
      text: errorMessage ?? t("mobile.general_error"),
    })
  }
  return errorModal
}

export default useHandleErrorModal
